import { Button } from 'components/button/Button';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from 'reducers/modal';
import * as Yup from 'yup';
import { Spinner } from 'components/spinner/Spinner';
import { TextArea } from 'components/formFields/TextArea';

export const VirtualAssessmentsAdjustmentModal = () => {
  const dispatch = useDispatch();


  const handleSubmit = (values: { note: string | null }) => {
    console.log('values', values);
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const validationSchema = Yup.object({
    note: Yup.string()
      .required('Please select a reason for the assessment adjustment')
      .typeError('Please select a reason for the assessment adjustment'),
  });


  return (
    <div className="VirtualAssessmentsAdjustmentModal">
      <Formik
        initialValues={{ note: '' }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ isValid, isSubmitting, values, setFieldValue }) => (
          <Form>
            <div className="VirtualAssessmentsAdjustmentModal__content VirtualAssessmentsModalContent Content">
              <div>
                <div className="VirtualAssessmentsAdjustmentModal__title">
                  Request adjustment to assessment
                </div>

                <div className="Paragraph">
                  Are you sure you wish to request an adjustment to this
                  assessment?
                </div>
              </div>
               <div className="SJTAdjustmentModal__textinput">
                  <TextArea
                    label="Additional notes"
                    name="note"
                    charLimit={100}
                  />
                </div>
            </div>
            <div className="ModalFooter">
              <Button
                priority="tertiary"
                type="button"
                onClick={handleCloseModal}
              >
                Cancel
              </Button>
              <Button
                className="Discard"
                priority="primary"
                type="submit"
                onClick={() => {}}
              >
                Submit
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
